import { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faEnvelope,
  faPaperPlane,
  faPhone,
} from "@fortawesome/free-solid-svg-icons";
import constants from "../constants/constants";
import { useUserParams } from "../hooks/useUserParams";

export default function InquiryCard() {
  const { getCurrentAgentNumber, getCurrentAgentEmail } = useUserParams();
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    message: "",
  });

  const [loading, setLoading] = useState(false);

  function handleChange(e) {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  }

  async function handleSubmit(e) {
    e.preventDefault();

    setLoading(true);

    try {
      console.log(formData);

      setFormData({
        name: "",
        email: "",
        message: "",
      });

    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className="overflow-hidden rounded-[28px] border border-harbour-border bg-harbour-surface shadow-[0_25px_70px_rgba(14,78,127,0.12)]">

      {/* Header */}
      <div className="bg-harbour-navy px-7 py-8 text-white">
        <div className="flex items-center gap-4">
          <div className="flex h-12 w-12 items-center justify-center rounded-full bg-harbour-accent/20">
            <FontAwesomeIcon
              icon={faEnvelope}
              className="text-xl text-harbour-accent"
            />
          </div>

          <div>
            <p className="text-xs uppercase tracking-[0.35em] text-white/60">
              Property Inquiry
            </p>

            <h3 className="mt-2 font-heading text-3xl leading-none">
              Contact Agent
            </h3>
          </div>
        </div>

        <p className="mt-5 text-sm leading-6 text-white/70">
          Interested in this property? Send a message and receive detailed
          information from our real estate team.
        </p>
      </div>


      {/* Form */}
      <form
        onSubmit={handleSubmit}
        className="space-y-5 px-7 py-8"
      >
        <div>
          <label className="mb-2 block text-xs uppercase tracking-[0.25em] text-harbour-muted">
            Name
          </label>

          <input
            required
            type="text"
            name="name"
            value={formData.name}
            onChange={handleChange}
            placeholder="Your name"
            className="
              w-full rounded-xl border border-harbour-border
              bg-harbour-background px-4 py-3
              text-sm text-harbour-text
              outline-none transition
              focus:border-harbour-accent
              focus:bg-white
            "
          />
        </div>

        <div>
          <label className="mb-2 block text-xs uppercase tracking-[0.25em] text-harbour-muted">
            Email
          </label>

          <input
            required
            type="email"
            name="email"
            value={formData.email}
            onChange={handleChange}
            placeholder="Email address"
            className="
              w-full rounded-xl border border-harbour-border
              bg-harbour-background px-4 py-3
              text-sm text-harbour-text
              outline-none transition
              focus:border-harbour-accent
              focus:bg-white
            "
          />
        </div>

        <div>
          <label className="mb-2 block text-xs uppercase tracking-[0.25em] text-harbour-muted">
            Message
          </label>

          <textarea
            required
            rows="4"
            name="message"
            value={formData.message}
            onChange={handleChange}
            placeholder="I am interested in this property..."
            className="
              w-full resize-none rounded-xl border border-harbour-border
              bg-harbour-background px-4 py-3
              text-sm text-harbour-text
              outline-none transition
              focus:border-harbour-accent
              focus:bg-white
            "
          />
        </div>

        <button
          type="submit"
          disabled={loading}
          className="
            group btn-harbour w-full
          "
        >
          <FontAwesomeIcon
            icon={faPaperPlane}
            className="transition-transform duration-300 group-hover:translate-x-1 mr-3"
          />
          {loading ? "Sending..." : "Send Inquiry"}
        </button>
      </form>

      {/* Agent Contact */}
      <div className="border-t border-harbour-border bg-harbour-background px-7 py-6">
        <p className="text-center text-xs uppercase tracking-[0.3em] text-harbour-muted">
          Prefer Direct Contact?
        </p>

        <div className="mt-4 space-y-3 text-center">
          <p className="flex items-center justify-center gap-2 text-sm text-harbour-text">
            <FontAwesomeIcon
              icon={faPhone}
              className="text-harbour-accent"
            />
            {getCurrentAgentNumber()}
          </p>

          <p className="flex items-center justify-center gap-2 text-sm text-harbour-text">
            <FontAwesomeIcon
              icon={faEnvelope}
              className="text-harbour-accent"
            />
            {getCurrentAgentEmail()}
          </p>
        </div>
      </div>
    </div>
  );
}
